(() => {
 'use strict';
 const node=document.getElementById('BellziGiftConfig');if(!node||!window.BellziGiftCore)return;
 const config=JSON.parse(node.textContent),core=window.BellziGiftCore,root=window.Shopify?.routes?.root||'/';
 const rules=config.rules||[];
 if(document.body.dataset.preview==='true'||!rules.some(rule=>rule.enabled&&rule.verified))return;
 const unavailable=new Set();let stored=[];try{stored=JSON.parse(sessionStorage.getItem('bellzi-gift-dismissed')||'[]');}catch(_){}
 const dismissed=new Set(Array.isArray(stored)?stored:[]);let queue=Promise.resolve(),lastCart=null;
 const remember=()=>{try{sessionStorage.setItem('bellzi-gift-dismissed',JSON.stringify([...dismissed]));}catch(_){}};
 function message(value){document.querySelectorAll('[data-gift-status]').forEach(el=>{el.textContent=value;el.hidden=!value;});}
 async function request(path,body){
  const response=await fetch(root+path,{method:body?'POST':'GET',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{}),signal:AbortSignal.timeout(10000)});
  const data=await response.json();if(!response.ok)throw Error(data.description||config.error);return data;
 }
 function lock(value){document.querySelectorAll('[name="checkout"],.shopify-payment-button').forEach(el=>{if('disabled'in el){if(value&&!el.disabled){el.dataset.giftLock='true';el.disabled=true;}else if(!value&&el.dataset.giftLock){el.disabled=false;delete el.dataset.giftLock;}}else {el.toggleAttribute('inert',value);}});}
 function dismiss(key){const item=lastCart?.items.find(i=>i.key===key);if(item&&core.isGift(item)){dismissed.add(item.properties[core.marker]);remember();}}
 async function sync(){
  let cart=await request('cart.js');lastCart=cart;
  if(!rules.some(r=>r.enabled)&&!cart.items.some(core.isGift))return cart;
  lock(true);
  try{
   for(const rule of rules)if(!core.eligible(cart,rule)){dismissed.delete(rule.id);unavailable.delete(rule.id);remember();}
   let next=core.plan(cart,rules,{dismissed,unavailable});
   if(Object.keys(next.updates).length)cart=await request('cart/update.js',{updates:next.updates});
   next=core.plan(cart,rules,{dismissed,unavailable});
   if(next.add){
    const rule=next.rule;
    try{
     const product=await request('products/'+encodeURIComponent(rule.handle)+'.js');
     const variant=product.variants?.find(v=>String(v.id)===String(rule.variantId));
     if(!variant?.available||variant.price<=0||product.variants.length!==1){unavailable.add(rule.id);message(config.unavailable);return cart;}
     await request('cart/add.js',{items:[next.add]});
    }catch(error){unavailable.add(rule.id);message(config.error);cart=await request('cart.js');}
    cart=await request('cart.js');
    const added=cart.items.filter(i=>i.properties?.[core.marker]===rule.id);
    if(added.some(i=>Number(i.final_line_price)!==0)){
     unavailable.add(rule.id);
     cart=await request('cart/update.js',{updates:Object.fromEntries(added.map(i=>[i.key,0]))});message(config.notFree);
    }else if(added.length){unavailable.delete(rule.id);message(config.added.replace('__GIFT__',rule.title));}
   }else if(!next.rule&&!unavailable.size){message('');}
   lastCart=cart;return cart;
  }finally{lock(false);}
 }
 function reconcile(){const job=queue.then(sync);queue=job.catch(()=>{});return job;}
 window.BellziGifts={reconcile,dismiss};
 document.addEventListener('click',e=>{const link=e.target.closest('[data-gift-remove]');if(link)dismiss(link.dataset.giftRemove);});
 document.addEventListener('submit',e=>{if(e.target.id==='CartForm')e.target.querySelectorAll('[data-gift-key]').forEach(input=>{if(Number(input.value)===0)dismiss(input.dataset.giftKey);});},true);
 document.addEventListener('submit',async event=>{
  const form=event.target;if(!form.matches('form[action$="/cart"]')||event.submitter?.name!=='checkout'||form.dataset.giftChecked==='true')return;
  if(!rules.some(r=>r.enabled)&&!lastCart?.items.some(core.isGift))return;
  event.preventDefault();event.stopImmediatePropagation();const submitter=event.submitter;
  try{
   if(form.id==='CartForm'){
    const original=JSON.parse(document.querySelector('[data-page-cart]')?.textContent||'null');
    const quantities=[...form.querySelectorAll('[name="updates[]"]')];
    if(!original||quantities.length!==original.items.length)throw Error(config.error);
    const updates=Object.fromEntries(original.items.map((item,index)=>[item.key,Number(quantities[index].value)]));
    if(Object.values(updates).some(value=>!Number.isInteger(value)||value<0))throw Error(config.error);
    await request('cart/update.js',{updates,note:form.querySelector('[name="note"]')?.value||''});
    await reconcile();location.assign(root+'checkout');return;
   }
   await reconcile();form.dataset.giftChecked='true';form.requestSubmit(submitter);delete form.dataset.giftChecked;
  }catch(_){message(config.error);}
 },true);
 const cartPage=document.querySelector('[data-cart-page]');
 if(rules.some(r=>r.enabled)||cartPage)reconcile().then(cart=>{
  if(cartPage){const original=JSON.parse(cartPage.querySelector('[data-page-cart]')?.textContent||'null');if(original&&JSON.stringify(original.items.map(i=>[i.key,i.quantity,i.final_line_price]))!==JSON.stringify(cart.items.map(i=>[i.key,i.quantity,i.final_line_price]))){location.reload();return;}}
  document.dispatchEvent(new CustomEvent('bellzi:cart-updated',{detail:{cart,open:false}}));
 }).catch(()=>message(config.error));
})();

